import React, { Component } from 'react';
import Nav from './nav'
import { Link, animateScroll as scroll} from 'react-scroll';

class Header extends Component {
  state = {};
  render() {
    return (
      <header>
     <Nav />
        <div className="head" id="cabeza">
            <h1>Wirelees< br/> Alonzo</h1>
            <div>
            <p><strong>Llegamos hasta donde estas... para conectarte hasta donde quieras llegar.</strong></p>
              <div><Link className="contact" to="contacto" smooth={true} style={{cursor:'pointer'}}>Contáctanos</Link></div>
            </div>
        </div>
      </header>
      
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/header.js